import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import { BUTTON_SIZES } from "components/DesignComponents/Button/types/enums";
import CopyButton from "components/DesignComponents/CopyButton";
import InputField, {
    INPUT_FIELD_SIZES
} from "components/DesignComponents/InputField";

import { GenerateKeyContentProps } from "./types";

const GenerateKeyContent = ({
    isLimitReached,
    isInvalidLockCode,
    isLoading,
    unlockKey,
    lockCode,
    handleLockCodeValueChange
}: GenerateKeyContentProps) => {
    const { t } = useTranslation();

    return (
        <>
            {unlockKey ? (
                <>
                    <BannerView
                        bannerType={BannerType.Success}
                        title={t(
                            "Dialog##unlocker##unlock key success message"
                        )}
                        css={css({
                            marginBottom: "16px"
                        })}
                    />

                    <div
                        css={css({
                            display: "flex"
                        })}
                    >
                        <InputField
                            fullWidth
                            size={INPUT_FIELD_SIZES.Small}
                            labelLeft={t("Dialog##unlocker##unlock key")}
                            value={unlockKey}
                            readOnly
                        />

                        <CopyButton
                            size={BUTTON_SIZES.Small}
                            copiedValue={unlockKey}
                            css={css({
                                alignSelf: "flex-end",
                                marginLeft: "8px"
                            })}
                        />
                    </div>
                </>
            ) : (
                <>
                    {isLimitReached && (
                        <BannerView
                            bannerType={BannerType.Error}
                            title={t("Dialog##unlocker##limit reached")}
                            css={css({
                                marginBottom: "16px"
                            })}
                        />
                    )}

                    <InputField
                        fullWidth
                        size={INPUT_FIELD_SIZES.Medium}
                        labelLeft={t("Dialog##unlocker##lock code")}
                        placeholder={t("Dialog##enter")}
                        value={lockCode}
                        errorText={
                            isInvalidLockCode
                                ? t("Dialog##unlocker##invalid lock code")
                                : null
                        }
                        readOnly={isLimitReached || isLoading}
                        onChange={handleLockCodeValueChange}
                    />
                </>
            )}
        </>
    );
};

export default GenerateKeyContent;
